import graphql__09899acd2a14b35d6a06 from "./__generated__/ContributionsMapLayout_map.graphql.js";import { createContext, useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { useDispatch } from "react-redux";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";

import MapDroppableZone from "../../../Maps/MapDroppableZone";
import MapDroppableZoneWithoutLimit from "../../../Maps/MapDroppableZoneWithoutLimit";

import { useNavigateTo } from "../../../Routes/RoutesContext";
import { isUnauthorized } from "../../../Utils/authorizations";
import MapWithSidebarLayout from "../../../Maps/MapWithSidebarLayout";
import { useMapContext } from "../../../Maps/MapContext";

import {
  addMapContribution,
  disableMapContributionCreationLocation
} from "../../../../reducers/map/contribution";

export const ContributionsMapLayoutContext = createContext({});

const ContributionsMapLayout = props => {
  const map = useFragment(ContributionsMapLayout_map, props.map);
  const { contributionZone } = map;
  const { slug: participativeModuleSlug } = map.participativeModule;
  const { contributionsSubmissionAuthorized } = map.participativeModule.authorizations;

  const hasContributionZone = contributionZone?.hasCoordinates;
  const canDropContribution = !isUnauthorized(contributionsSubmissionAuthorized);
  const displayDroppableZone = canDropContribution && hasContributionZone;
  const displayDroppableZoneWithoutLimit = canDropContribution && !hasContributionZone;

  const { children } = props;
  const { mapKey } = useMapContext();

  const dispatch = useDispatch();

  const navigateTo = useNavigateTo();
  const handleZoneClicked = useCallback(
    dropResult => {
      dispatch(disableMapContributionCreationLocation(mapKey));
      dispatch(addMapContribution(mapKey, { ...dropResult, explicitlyGeolocated: true }));
      navigateTo("newContribution", { participativeModuleSlug });
    },
    [dispatch, mapKey, navigateTo, participativeModuleSlug]
  );

  return (
    <MapWithSidebarLayout map={map}>
      <DndProvider backend={HTML5Backend}>
        {children}

        {displayDroppableZone && (
          <MapDroppableZone
            droppableZone={contributionZone}
            onClickInZone={handleZoneClicked}
          />
        )}

        {displayDroppableZoneWithoutLimit && (
          <MapDroppableZoneWithoutLimit
            droppableZone={contributionZone}
            onClickInZone={handleZoneClicked}
          />
        )}
      </DndProvider>
    </MapWithSidebarLayout>
  );
};

const ContributionsMapLayout_map = graphql__09899acd2a14b35d6a06;

export default ContributionsMapLayout;
